import React, { useCallback, useEffect, useState } from 'react'
import classnames from 'classnames'
import message from 'antd/lib/message'

import { InputImage, PrimaryButton } from 'components'
import { apiManager } from 'helpers'
import cls from './HostPortalStatCard/HostPortalStatCard.module.scss'

const EventGallery = ({ event }) => {
  const [galleryImages, setGalleryImages] = useState([])

  useEffect(() => {
    if (event) {
      setGalleryImages(event.gallery.map(({ media }) => media))
    }
  }, [event])

  const handeImageUpload = useCallback(
    async image => {
      try {
        const {
          data: { media },
        } = await apiManager.addEventGalleryImage({
          eventId: event.id,
          data: {
            image,
          },
        })
        message.success('Image added successfully')

        setGalleryImages(images => [...images, media])
      } catch (error) {
        message.error(error.message || 'Please try again')
      }
    },
    [event]
  )

  return (
    <div className={classnames(cls.statContainer, 'p-4 block')}>
      <div className="flex items-center justify-between mb-4">
        <div className="text-lg font-semibold">Gallery</div>
        <PrimaryButton className="h-9 text-sm relative">
          Add Image
          <InputImage title="Upload image" name="imageData" onChange={handeImageUpload} />
        </PrimaryButton>
      </div>
      <div className="flex flex-wrap items-start w-full">
        {galleryImages.map(media => (
          <div key={media.id} className="mb-4 px-2 w-1/2 md:w-1/3">
            <img src={media.url} alt="gallery" className="w-full" />
          </div>
        ))}
      </div>
    </div>
  )
}

export default EventGallery
